import { render } from "./DynamicScrollPanel.vue?vue&type=template&id=0eb30950&ts=true"
import script from "./DynamicScrollPanel.vue?vue&type=script&lang=ts"
export * from "./DynamicScrollPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicScrollPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eb30950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eb30950', __exports__)) {
    api.reload('0eb30950', __exports__)
  }
  
  module.hot.accept("./DynamicScrollPanel.vue?vue&type=template&id=0eb30950&ts=true", () => {
    api.rerender('0eb30950', render)
  })

}


export default __exports__